import angular from 'angular';

angular.module('webTools').controller('ReportsCtrl', ['$scope', '$window', 'Reports',
	function($scope, $window, Reports) {

	    $scope.data = $scope.data || {};

	    $scope.data.showReportFrame = false;
	    $scope.showReportList = false;
	    $scope.currentReport = '';

	    $scope.reportList = Reports.getReportList().promise.then(function(data) {
	        $scope.reportList = data;
	        $scope.showReportList = true;
	    });

	    $scope.loadReport = function(reportName) {
	        $scope.currentReport = reportName;
	        $scope.$broadcast('loadReport', reportName);
	        $scope.data.showReportFrame = false;
    }

    $scope.onResize = () => {
      if(angular.element($window).height() < 250) { return; }

      var topBarHeight = 50; // height of header
      var centerHeight = angular.element($window).height() - topBarHeight;

      angular.element('.iframe-container').height(centerHeight);
    }

    angular.element($window).on('resize', function (e) {
      $scope.onResize();
    });

    $scope.$on('$destroy', () => angular.element($window).off('resize', $scope.onResize()));

    $scope.onResize()
	}
]);

angular.module('webTools').directive('reportViewer', [
    function() {
        return {
            restrict: 'A',
            link: function(scope, element, attributes) {
                scope.$on('loadReport', function(e, reportName) {
                    element.attr('src', '/report-viewer.aspx?report=' + reportName)
                });
            }
        }
    }
]);

angular.module('webTools').service('Reports', ['$q', '$http',
    function($q, $http) {

        return {
            getReportList: function() {

                var promise = $q.defer();

                $http.get('/api/reportlist/getreportlist')
                .then(function(response) {
					let data = response.data;
                    promise.resolve(data);
                });

                return promise;
            }
        }
    }
]);